export default [
  {
    path: '/search-main',
    name: 'searchMain',
    component: () => import('../../pages/search/index.vue'),
    meta: {
      title: '搜索',
      authorization: true
    }
  }
];
